var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        { attrs: { size: "mini" }, on: { click: _vm.enableAll } },
        [_vm._v("启用全部按钮")]
      ),
      _c("el-button", { attrs: { size: "mini" }, on: { click: _vm.showAll } }, [
        _vm._v("显示全部按钮")
      ]),
      _c(
        "fu-table",
        {
          attrs: {
            data: _vm.tableData,
            columns: _vm.columns,
            "local-key": "TableOperations"
          }
        },
        [
          _c("el-table-column", { attrs: { type: "selection" } }),
          _c("el-table-column", {
            attrs: { prop: "date", label: "日期", "min-width": "180" }
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "姓名", "min-width": "180", fix: "" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "address",
              label: "地址",
              "min-width": "300",
              show: false
            }
          }),
          _c("fu-table-operations", {
            attrs: {
              ellipsis: 2,
              columns: _vm.columns,
              buttons: _vm.buttons,
              label: "操作",
              fix: ""
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }